import { MultiStepForm, UserProfileModel } from '@nw/fields-manager';
import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BaseProductDetail } from './BaseProductDetail';
import { PeriodicInstallmentPricingDetails } from './PeriodicInstallmentPricingDetails';

export class PeriodicInstallmentProductDetail extends BaseProductDetail {
  readonly installmentType = 'PERIODIC';
  readonly periodicInstallmentConfigs: {
    config_id: string;
    no_of_installments: number;
    interval_type: 'MONTHS';
    interval_value: number;
    interest_amount_in_least_subunit: number;
  }[];
  readonly appliedConfigId?: string;
  readonly initialPricingDetails: PeriodicInstallmentPricingDetails;
  currentPricingDetails: PeriodicInstallmentPricingDetails;

  constructor(
    productDetails: GetProductDetailsResponseType,
    userProfileDetails: UserProfileModel | null = null
  ) {
    super(productDetails);

    this.periodicInstallmentConfigs =
      this.installmentPricingDetails?.periodic_installment_pricing_configs ||
      [];

    const periodicDetails =
      this.productPurchaseDetailsForUser?.pricing_details
        ?.periodic_installment_details;
    this.appliedConfigId = periodicDetails?.applied_pricing_config_id;

    this.initialPricingDetails = new PeriodicInstallmentPricingDetails(
      productDetails
    );
    this.currentPricingDetails = this.initialPricingDetails;
    this.form = this.parsedUserExtraInfoConfig
      ? new MultiStepForm(
          this.parsedUserExtraInfoConfig.registration_form_details,
          userProfileDetails,
          this
        )
      : undefined;
  }

  shouldShowCouponApplyButton(): boolean {
    return (
      this.currentPricingDetails.amountToBePaid > 0 &&
      (this.parsedExtraData?.should_show_coupon_apply_button ?? true)
    );
  }

  updateCurrentDetailsWithReferralCodeResponse(
    pricingDetailsObject: PeriodicInstallmentPricingDetails
  ) {
    this.currentPricingDetails = pricingDetailsObject;
  }

  updateCurrentDetailsWithInitialPricingDetails() {
    this.currentPricingDetails = this.initialPricingDetails;
  }

  getConfigById(configId: string) {
    return this.periodicInstallmentConfigs.find(
      (config) => config.config_id === configId
    );
  }

  getCurrentInstallmentConfig() {
    return this.appliedConfigId
      ? this.getConfigById(this.appliedConfigId)
      : undefined;
  }
}
